
<template>
  <div name="schools" class="w-full mx-auto">
    <transition name="fade" v-if="loading">
      <div class="loading">
        <span class="fa fa-spinner fa-spin"></span> Loading
      </div>
    </transition>

    <noaccess v-if="!hasAccess" :blocktype="'outcome'"></noaccess>

    <div class="w-95p mx-auto bg-white rounded-xl p-4 mt-2 mb-4 panel-header text-base">
      Currently {{consuls.length}} schools available within your organisation.
      <div class="block float-right">
 <router-link to="/schools"   class="text-red-300 text-xs align-text-bottom" >
                 view all
                      </router-link>
      </div>
    </div>

    <div class="flex flex-wrap -mt-4 w-full text-xs">
      <div class="md:w-1/3 sm:w-full p-4">
        <div class="bg-white p-1 rounded-lg">
          <h3 class="panel-header p-4">Assessments</h3>

          <div v-if="topByAssessments.length === 0" class="w-full text-center">
            <p class="mt-2 text-gray-400">No assessments found</p>
          </div>
          <div v-else class="p-2">
            <table class="w-full table-wrapper">
              <thead class="opacity-25 text-left">
                <th class="pl-2 font-bold">Current top 3</th>
                <th class="pl-3 text-gray-700">Count</th>
              </thead>
              <tbody>
                <tr
                  v-for="item in topByAssessments"
                  :key="item.id"
                  class="hover:opacity-50 cursor-pointer"
                  @click="showSchoolReport(item)"
                >
                  <td class="w-7/12">{{ item.name }}</td>
                  <td class="w-3/12 pl-6">
                    {{ item.assessment_count }}
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="w-full table-wrapper my-8">
              <thead class="opacity-25 text-left">
                <th class="pl-2 font-bold">Current bottom 3</th>
              </thead>
              <tbody>
                <tr
                  v-for="item in bottomByAssessments"
                  :key="item.id"
                  class="hover:opacity-50 cursor-pointer"
                  @click="showSchoolReport(item)"
                >
                  <td class="w-7/12">{{ item.name }}</td>
                  <td class="w-3/12 pl-6">
                    {{ item.assessment_count }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="md:w-1/3 sm:w-full p-4">
        <div class="bg-white p-1 rounded-lg">
          <h3 class="panel-header p-4">EC Activities</h3>
          <div v-if="topByActivities.length === 0" class="w-full text-center">
            <p class="mt-2 text-gray-400">No activities found</p>
          </div>
          <div v-else class="p-2">
            <table class="w-full table-wrapper">
              <thead class="opacity-25 text-left">
                <th class="pl-2 font-bold">Current top 3</th>
                <th class="pl-1 text-gray-700">Count (pupils)</th>
              </thead>
              <tbody>
                <tr
                  v-for="item in topByActivities"
                  :key="item.id"
                  class="hover:opacity-50 cursor-pointer"
                  @click="showSchoolReport(item)"
                >
                  <td class="w-7/12">{{ item.name }}</td>
                  <td class="w-3/12 pl-6">
                    {{ item.activity_count }}
                    <span class="text-xs opacity-50">
                      ({{ item.activity_register_count }})
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="w-full table-wrapper my-8">
              <thead class="opacity-25 text-left">
                <th class="pl-2 font-bold">Current bottom 3</th>
              </thead>
              <tbody>
                <tr
                  v-for="item in bottomByAssessments"
                  :key="item.id"
                  class="hover:opacity-50 cursor-pointer"
                  @click="showSchoolReport(item)"
                >
                  <td class="w-7/12">{{ item.name }}</td>
                  <td class="w-3/12 pl-6">
                    {{ item.activity_count }}
                    <span class="text-xs opacity-50">
                      ({{ item.activity_register_count }})
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="md:w-1/3 sm:w-full p-4">
        <div class="bg-white p-1 rounded-lg">
          <h3 class="panel-header p-4">Events</h3>
          <div v-if="topByEvents.length === 0" class="w-full text-center">
            <p class="mt-2 text-gray-400">No events found</p>
          </div>
          <div v-else class="p-2">
            <table class="w-full table-wrapper">
              <thead class="opacity-25 text-left">
                <th class="pl-2 font-bold">Current top 3</th>
                                 <th class="pl-1 text-gray-700">Count (pupils)</th>

              </thead>
              <tbody>
                <tr
                  v-for="item in topByEvents"
                  :key="item.id"
                  class="hover:opacity-50 cursor-pointer"
                  @click="showSchoolReport(item)"
                >
                  <td class="w-7/12">{{ item.name }}</td>
                  <td class="w-3/12 pl-6">
                    {{ item.event_count }}
                    <span class="text-xs opacity-50">
                      ({{ item.event_register_count }})
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="w-full table-wrapper my-8">
              <thead class="opacity-25 text-left">
                <th class="pl-2 font-bold">Current bottom 3</th>
              </thead>
              <tbody>
                <tr
                  v-for="item in bottomByEvents"
                  :key="item.id"
                  class="hover:opacity-50 cursor-pointer"
                  @click="showSchoolReport(item)"
                >
                  <td class="w-7/12">{{ item.name }}</td>
                  <td class="w-3/12 pl-6">
                    {{ item.event_count }}
                    <span class="text-xs opacity-50">
                      ({{ item.event_register_count }})
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dropdown from "@/components/Dropdown.vue";

const noaccess = () => import("@/components/NoAccess.vue");
import { SchoolService } from "@/services/school.service";

export default {
  name: "schools",
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    activeDropdown() {
      this.selectedActive = this.actives[0];
      return this.actives;
    },
    hasSchoolsSelected() {
      return this.selectedSchools.length > 0;
    },
    topByAssessments() {
      var results = _.orderBy(
        this.consuls,
        ["assessment_count"],
        "desc"
      );
      return results.slice(0, 3);
    },
    bottomByAssessments() {
      var results = _.orderBy(
        this.consuls,
        ["assessment_count"],
        "asc"
      );
      return results.slice(0, 3);
    },
    topByActivities() {
      var results = _.orderBy(
        this.consuls,
        ["activity_count"],
        "desc"
      );
      return results.slice(0, 3);
    },
    bottomByActivities() {
      var results = _.orderBy(
        this.consuls,
        ["activity_count"],
        "asc"
      );
      return results.slice(0, 3);
    },
    topByEvents() {
      var results = _.orderBy(
        this.consuls,
        ["event_count"],
        "desc"
      );
      return results.slice(0, 3);
    },
    bottomByEvents() {
      var results = _.orderBy(
        this.consuls,
        ["event_count"],
        "asc"
      );
      return results.slice(0, 3);
    },
  },
  data() {
    return {
      errored: false,
      loading: true,
      hasAccess: false,
      consuls: [],
      search: "",
    };
  },
  created() {
    this.loading = true;
    this.hasAccess = this.currentUser.isSchool == false;
    this.fetchData();
  },
  methods: {
    fetchData() {
      SchoolService.getAll("consuls/reporting")
        .then((response) => this.buildConsulList(response.data.data))
        .catch((err) => {
          console.log("Consuls " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildConsulList(data) {
      this.consuls = data;
    },
    showSchoolReport(school) {
      this.$router.push({
        name: "OrgSchoolReport",
        params: { schools: [school] },
      });
    },
  },
  components: {
    dropdown,
    noaccess,
  },
};
</script>


<style scoped>
.button:disabled {
  @apply bg-gray-500 text-gray-400 cursor-not-allowed;
}
</style>
